import {
  START_LISTGIFT,
  IS_LISTGIFT,
  IS_LISTGIFT_NUMGIFT,
  ERROR_LISTGIFT
} from "../actions/giftActions";

const initialState = {
  listGift: [],
  from: 0,
  to: 9,
  numOfGift: 0,
  error: false,
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_LISTGIFT:
      return {
        ...state,
        error: false,
        loading: true
      };
    case IS_LISTGIFT:
      return {
        ...state,
        listGift: action.payload,
        isLogged: true,
        loading: false,
        error: false
      };
    case IS_LISTGIFT_NUMGIFT:
      return {
        ...state,
        numOfGift: action.payload
      };
    case ERROR_LISTGIFT:
      return {
        ...state,
        error: true,
        loading: false
      };
    default:
      return state;
  }
}
